// extracted by mini-css-extract-plugin
module.exports = {"faq":"styles-module--faq--1u8ql"};